const isDevEnv = () => {
    return !!window && !!window.location && window.location.hostname === 'localhost';
}
const getAssetPath = () => {
    let pathNameParts = window.location.pathname.split('/').filter(part => !!part);
    if(pathNameParts.length == 0)
        return '';
    if(pathNameParts[0] == 'karte')
        return window.location.pathname;
    return '/karte/';
}

export default {
    dc: {
        apiHost: isDevEnv() ? 'https://donautouristik.pixeldev.at' : 'https://www.donaureisen.at',
        apiEndpoint: 'ba476d33-c6f8-4e05-a12c-32ea0c105420',//'fc55c7d3-d79e-438d-90d0-113d5b6b5a01'
        categories: [
            {
                key: 'reisearten',
                name: 'Reisearten',
                icon: 'suitcase-rolling',
                id: '2e9afcb7-318b-4ccc-ae2b-001c69e2e9b8'
            },
            {
                key: 'reiseunterarten',
                name: 'Reiseunterarten',
                icon: 'atlas',
                id: '8718c8b8-5f6d-4062-b7af-25693a37ac9e'
            },
            {
                key: 'jahreszeiten',
                name: 'Jahreszeiten',
                icon: 'cloud-sun-rain',
                id: '0525ef03-9c29-405f-ac08-a88cd12dbcea'
            },
            {
                key: 'reisetypen',
                name: 'Reisetypen',
                icon: 'umbrella-beach',
                id: '7af0d28c-0111-42c6-a11f-e4393f1c8291'
            },
            {
                key: 'regionen',
                name: 'Regionen',
                icon: 'tree',
                id: '61a98b0e-41f0-4573-9287-bccc0d3a6c60'
            },
            {
                key: 'laender',
                name: 'Länder',
                icon: 'flag',
                id: '864048ac-9e36-4b0c-a7f4-edd457e3107c'
            }/*,
            {
                key: 'angebotskategorien',
                name: 'Angebotskategorien',
                icon: 'skiing',
                id: '870f1152-a819-4525-8181-b50d633b2e30'
            }//*/
        ]
    },
    assetPath: getAssetPath(),//'/karte/fr/',
    defaults: {
        thumbnail: "https://via.placeholder.com/200x150.jpg",
        detailImage: "https://via.placeholder.com/500x400.jpg"
    },
    colors: {
        default: '#185575',
        active: '#f39325',
        white: '#ffffff',
        black: '#000000'
    }
};